import React, { useState, useEffect, useMemo } from 'react';
import { Grid2, TextField, InputAdornment, IconButton, Box, Tabs, Tab, Badge } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Filter } from '../../../../assets/SVG/filter.svg';
import { ReactComponent as SearchIcon } from '../../../../assets/SVG/Search-Icon.svg';
import { filterSearchTextBoxSx, FilterIconSx, subTabSx, } from '../../Stocks/stock.helper';
import { activeBadgeSx } from '../../Common/inventory.helper';
import FilterModal from '../Modals/FilterModal';
import { tabButtonStyles } from '../stockTransfer.helper';
import { useStockTransferStore } from '../../Store/useStockTransferstore';
import ProspectiveListComponent from './TabComponents/ProspectiveListComponent';
import ReceiveListComponent from './TabComponents/ReceiveListComponent';
import styles from '../StockTransfer.module.css';


const ReceiveListPage: React.FC = () => {
  const { t: tStockTransfer } = useTranslation('stockTransfer_config');
  // Search is managed in Zustand store
  const [openFilter, setOpenFilter] = useState(false);
  const stockTransferStore = useStockTransferStore();
  const { searchText, setSearchText, receiveTopTab, setReceiveTopTab } = stockTransferStore;

  // Set default tab to PROSPECTIVE on component mount
  useEffect(() => {
    setReceiveTopTab('PROSPECTIVE');
  }, [setReceiveTopTab]);


  const onSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value);
  };

  const topTabs: Array<{ value: 'PROSPECTIVE' | 'RECEIVED'; label: string }> = [
    { value: 'PROSPECTIVE', label: tStockTransfer('Prospective') },
    { value: 'RECEIVED', label: tStockTransfer('Received') },
  ];

  const isFilterApplied = useMemo(() => {
    return !!(
      stockTransferStore.fromStoreId ||
      stockTransferStore.toStoreId ||
      stockTransferStore.fromDate ||
      stockTransferStore.toDate
    );
  }, [stockTransferStore.fromStoreId, stockTransferStore.toStoreId, stockTransferStore.fromDate, stockTransferStore.toDate]);
 

  return (
    <>
      <Box p={1} data-testid="receive-list-page-container" className={styles.listPageContainer}>
        <Grid2 container alignItems="center" justifyContent="space-between" width="100%" px={3} mb={2} spacing={2} data-testid="receive-header-container">
          <Grid2 size={{ xs: 12, md: 6 }} data-testid="receive-tabs-container">
            <Box>
              <Tabs
                sx={subTabSx}
                value={receiveTopTab}
                onChange={(_, newValue) => setReceiveTopTab(newValue)}
                data-testid="receive-top-tabs"
              >
                {topTabs.map((tab) => (
                  <Tab
                    key={tab.value}
                    label={tab.label}
                    value={tab.value}
                    data-testid={`receive-tab-${tab.value.toLowerCase()}`}
                    sx={{
                      ...(tabButtonStyles.base),
                      ...(receiveTopTab === tab.value && tabButtonStyles.selected),
                      textAlign: 'center',
                    }}
                  />
                ))}
              </Tabs>
            </Box>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6 }} container alignItems="center" spacing={1} justifyContent="flex-end" data-testid="receive-actions-container">
            <Grid2>
              <TextField
                size="small"
                placeholder={tStockTransfer('Search By Receive No / Issue No / Patient')}
                variant="outlined"
                value={searchText}
                onChange={onSearchChange}
                data-testid="receive-search-input"
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    )
                  }
                }}
                fullWidth
                sx={{ ...filterSearchTextBoxSx, minWidth: { xs: '100%', sm: 360, md: 420 }, borderRadius: 2 }}
              />
            </Grid2>
            <Grid2>
              <IconButton onClick={() => setOpenFilter(true)} data-testid="receive-filter-btn">
                <Badge
                  variant="dot"
                  color="error"
                  invisible={!isFilterApplied}
                  sx={activeBadgeSx}
                >
                  <Filter style={FilterIconSx} />
                </Badge>
              </IconButton>
            </Grid2>
          </Grid2>
        </Grid2>
        <Grid2 px={3} data-testid="receive-tab-content-container" className={styles.tabContentContainer}>
          {receiveTopTab === 'PROSPECTIVE' ? (
            <ProspectiveListComponent />
          ) : (
            <ReceiveListComponent />
          )}
        </Grid2>

        {/* Modal holder */}
        <FilterModal open={openFilter} onClose={() => setOpenFilter(false)} />
      </Box>
    </>
  );

};
export default ReceiveListPage;